var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pl-0 pr-0",attrs:{"fluid":""}},[_c('iframe',{attrs:{"src":_vm.baseURL + '?user=' + _vm.currentUser.email+ '&name=' + encodeURI(_vm.currentUser.displayName),"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }